module.exports = __webpack_public_path__ + "img/1184615147.81fcd757.jpg";